<template>
  <div class="company">
    <!-- 头部 -->
    <div class="title">
      <div class="titleBox">
        <img src="../../../assets/slzndx.png" alt="" />
        <span>公告栏</span>
        <span>></span>
        <span>公告栏</span>
      </div>
    </div>
    <div class="gs_content">
      <p class="gs_title">
        建设项目职业病防护设施“三同时”工作公示信息表
      </p>
      <p class="gs_time">发布者：fangminghua  <span style="margin-left:20px"> 发布时间：2023-05-08</span></p>
      <div>
        <img src="https://picture.hwason.cn/image/png/313842331421379520.png " alt="" style="width:850px;height:1000px;">
        <img src="https://picture.hwason.cn/image/png/313842447975736448.png" alt="" style="width:850px;height:1000px;" >
      </div>
      <!-- <p class="gs_time">发布者：fangminghua  <span style="margin-left:20px"> 发布时间：2023-03-16</span></p>
      <p class="gs_desc">项目名称：南京江河华晟医学检验实验室建设项目</p>
      <p class="gs_desc">建设单位：南京江河华晟医学检验实验室有限公司</p>
      <p class="gs_desc">项目性质：新建</p>
      <p class="gs_desc">
        建设地址：南京市江北新区新锦湖路3-1
        号中丹生态生命科学产业园二期C座4层、D座4层
      </p>
      <p class="gs_desc">联系人员：方鸣华</p>
      <p class="gs_desc">联系电话：13382404212</p>
      <p class="gs_desc">公示日期：自公示发布日起，20个工作日止</p>
      <p class="gs_desc">
        公示内容：竣工环境保护验收报告、验收意见及签到表、一般变动分析报告
      </p>
      <div  class="pdf_content" @click="watchPdf(1)">
        <div class="pdf_image">
          <img src="../../../assets/PDF.png" alt="" style="width:100%;height:100%;">
        </div>
        <div class="pdf_text">
          南京江河华晟医学检验实验室建设项目验收报告.pdf
        </div>
      </div>
      <div  class="pdf_content"  @click="watchPdf(2)">
        <div class="pdf_image">
          <img src="../../../assets/PDF.png" alt="" style="width:100%;height:100%;">
        </div>
        <div class="pdf_text">
          南京江河华晟医学检验实验室建设项目一般变动环境影响分析.pdf
        </div>
      </div>
      <div  class="pdf_content"  @click="watchPdf(3)">
        <div class="pdf_image">
          <img src="../../../assets/PDF.png" alt="" style="width:100%;height:100%;">
        </div>
        <div class="pdf_text">
          验收意见及签到表.pdf
        </div>
      </div> -->
    </div>
    <!-- 新闻列表 -->
    <div class="newsDate">
      <div
        :class="classList[index].news_other"
        v-for="(item, index) in newsList"
        :key="item.ID"
        @mouseover="changeActive(index)"
        @mouseleave="changeUnActive(index)"
        @click="toDetail(item.filePath)"
      >
        <div :class="classList[index].news_other_time">
          <p class="time">{{ item.month }}</p>
          <p class="date">{{ item.day }}</p>
        </div>
        <div class="right">
          <p :class="classList[index].news_title_1">{{ item.title }}</p>
          <!-- <p>{{ item.summary }}</p> -->
          <img
            class="rightImg"
            style="width: 36px; height: 38px"
            :src="pdfUrl[index]"
          />
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="5"
      layout="total, prev, pager, next, jumper"
      :total="totalCount"
      class="news-pagination"
      style="float: right; margin-bottom: 20px"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      pdfUrl: [
        '../../../../../static/img/notice/pdf_1.png',
        '../../../../../static/img/notice/pdf_1.png',
        '../../../../../static/img/notice/pdf_1.png',
        '../../../../../static/img/notice/pdf_1.png',
        '../../../../../static/img/notice/pdf_1.png',
      ],
      currentPage: 1,
      totalCount: 0,
      newsList: [
        {
          thumbnail: '',
        },
      ],

      classList: [
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1',
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1',
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1',
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1',
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1',
        },
      ],
    }
  },
  mounted() {
    this.getNews()
  },
  methods: {
    watchPdf(value){
      if(value===1){
          window.open('https://picture.hwason.cn/file/pdf/294578550924142592.pdf')
      }else  if(value===2){
        window.open('https://picture.hwason.cn/file/pdf/294578678233851904.pdf')
      }else if(value===3){
         window.open('https://picture.hwason.cn/file/pdf/294578784353938048.pdf')
      }
    },
    toDetail(path) {
      let url = `http://www.hwason.cn/${path}`
      // console.log('url',url); encodeURI(url)
      window.open(url)
    },
    handleCurrentChange(val) {
      const vm = this
      vm.currentPage = val
      vm.getNews()
    },

    // 获取新闻列表
    getNews() {
      const vm = this
      let params = {
        pageNo: vm.currentPage,
        pageSize: 5,
      }

      vm.axios
        .get('/notice/queryNoticeList', { params: params })
        .then((res) => {
          vm.newsList = []
          res.data.noticeList.list.forEach((val) => {
            val.publishtime = moment(val.createDate).utc(0).format('YYYY/MM/DD')
            // console.log(val);
            // console.log('公告',val.publishtime);
            val.day = val.publishtime.split('/')[2]
            val.month =
              val.publishtime.split('/')[0] +
              '/' +
              val.publishtime.split('/')[1]
            vm.newsList.push(val)
          })

          vm.totalCount = res.data.noticeList.count[0].count
        })
    },

    changeActive(index) {
      let vm = this
      let class_active = {
        news_other: 'news-other-active',
        news_other_time: 'news-other-time-active',
        news_title_1: 'news-title-1-active',
      }
      vm.$set(vm.classList, index, class_active)
      vm.$set(vm.pdfUrl, index, '../../../../../static/img/notice/pdf_2.png')
    },

    changeUnActive(index) {
      let vm = this
      let class_unactive = {
        news_other: 'news-other',
        news_other_time: 'news-other-time',
        news_title_1: 'news-title-1',
      }
      vm.$set(vm.classList, index, class_unactive)
      vm.$set(vm.pdfUrl, index, '../../../../../static/img/notice/pdf_1.png')
    },
  },
}
</script>

<style lang="scss" scoped>
.company {
  position: relative;
  padding: 0 8%;
  // padding-top: 90px;
  padding-top: 20px;
  overflow: hidden;
  .title {
    width: 100%;
    height: 60px;
    .titleBox {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      // width: 1598px;
      padding: 0 8%;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #999999;
      color: #999999;

      img {
        vertical-align: middle;
      }
      span {
        padding: 0 6px;
        font-size: 16px;
      }
    }
  }
  .gs_content {
    min-height: 500px;
    width: 800px;
    // border: 1px solid red;
    margin: 0 auto;
    .gs_title {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 30px;
    }
    .gs_time {
      font-size: 16px;
      color: #8c8c8c;
      margin: 15px 0 20px 0;
      text-align: center;
    }
    .gs_desc {
      font-size: 17px;
      color: #474747;
      margin: 20px 0;
    }
    .pdf_content{
      margin: 10px;
      display: flex;
      justify-content: flex-start;
      align-content: center;
      cursor: pointer;
      .pdf_image{
        width: 40px;
        height: 36px;
        background: #fff;
        padding: 0;
        border-radius:8px;
      }
      .pdf_text{
        font-size: 16px;
        margin-left:10px; 
        height: 36px;
        line-height: 36px;
        color: #8c8c8c;
      }
      .pdf_text:hover{
        color: #0068b7;
        font-weight: bolder;
      }
    }
  }
  .newsDate {
    padding-top: 54px;
    .news-other {
      display: flex;
      margin-bottom: 30px;
      cursor: pointer;
      .news-other-time {
        width: 180px;
        height: 110px;
        text-align: center;
        background-color: #999;
        color: #fff;
        margin-right: 60px;
        .time {
          height: 45px;
          line-height: 55px;
        }
        .date {
          font-size: 28px;
          font-weight: 700;
        }
      }
      .right {
        flex: 1;
        height: 110px;
        border-bottom: 1px solid #999999;
        font-size: 14px;
        color: #666666;

        .news-title-1 {
          height: 44px;
          line-height: 106px;
          color: #333333;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
          margin-right: 15px;
        }
        .rightImg {
          vertical-align: middle;
        }
      }
    }

    .news-other-active {
      display: flex;
      margin-bottom: 30px;
      cursor: pointer;
      .news-other-time-active {
        width: 180px;
        height: 110px;
        text-align: center;
        background-color: #0068b7;
        color: #fff;
        margin-right: 60px;
        .time {
          height: 45px;
          line-height: 55px;
        }
        .date {
          font-size: 28px;
          font-weight: 700;
        }
      }
      .right {
        flex: 1;
        height: 110px;
        border-bottom: 1px solid #0068b7;
        font-size: 14px;
        color: #666666;

        .news-title-1-active {
          height: 44px;
          line-height: 106px;
          color: #0068b7;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
          margin-right: 15px;
        }
        .rightImg {
          vertical-align: middle;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/website/notice/notice.vue